<template>
<div class="wrapper">
    <div class="award-wrapper">
        <div :class="{award: true, chosen: current == index}" @click="select(index)" v-for="(item, index) in wishData.desires" :key="item.index">
            <span>{{item.name}}</span>
            <img :src="item.img" alt="">
        </div>
        <!-- <div :class="{award: true, chosen: current == 2}" @click="select(2)">
            <span>金币*1000</span>
            <img src="http://yunying.dodjoy.com/wgame/image/jinbi.png" alt="">
        </div>
        <div :class="{award: true, chosen: current == 3}" @click="select(3)">
            <span>金币*1000</span>
            <img src="http://yunying.dodjoy.com/wgame/image/jinbi.png" alt="">
        </div>
        <div :class="{award: true, chosen: current == 4}" @click="select(4)">
            <span>金币*1000</span>
            <img src="http://yunying.dodjoy.com/wgame/image/jinbi.png" alt="">
        </div>
        <div :class="{award: true, chosen: current == 5}" @click="select(5)">
            <span>金币*1000</span>
            <img src="http://yunying.dodjoy.com/wgame/image/jinbi.png" alt="">
        </div>
        <div :class="{award: true, chosen: current == 6}" @click="select(6)">
            <span>金币*1000</span>
            <img src="http://yunying.dodjoy.com/wgame/image/jinbi.png" alt="">
        </div>
        <div :class="{award: true, chosen: current == 7}" @click="select(7)">
            <span>金币*1000</span>
            <img src="http://yunying.dodjoy.com/wgame/image/jinbi.png" alt="">
        </div>
        <div :class="{award: true, chosen: current == 8}" @click="select(8)">
            <span>金币*1000</span>
            <img src="http://yunying.dodjoy.com/wgame/image/jinbi.png" alt="">
        </div>
        <div :class="{award: true, chosen: current == 9}" @click="select(9)">
            <span>金币*1000</span>
            <img src="http://yunying.dodjoy.com/wgame/image/jinbi.png" alt="">
        </div> -->
    </div>
    <img src="../../assets/modal/confirm.png" alt="" class="confirm" @click="handleConfirm">
</div>
</template>

<script>
export default {
    name: 'wishBoard',
    props: ["wishData"],
    data() {
        return {
            current: 1
        }
    },
    methods: {
        select(s) {
            this.current = s
        },
        handleConfirm() {
            const id = this.wishData.desires[this.current].id
            this.$emit('wishBoard-confirm', id)
        }
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    width: 97.87vw;
    margin: 0 auto;
    min-height: 94.54vw;
    background-image: url("../../assets/modal/board.png");
    background-size: 100% 100%;
}
.award-wrapper {
    display: flex;
    color: white;
    font-size: 12px;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 74%;
    margin: 0 auto;
    padding-top: 31vw;
    .award {
        width: 23.52vw;
        background-image: url("../../assets/modal/award1.png");
        background-size: 100% 100%;
        text-align: center;
        margin: 1vw 0;
        img {
            width: 8vw;
            display: block;
            margin: 0 auto;
        }
    }
    .chosen {
        background-image: url("../../assets/modal/award2.png");
    }
}
.confirm {
    width: 29.26vw;
    margin: 5vw auto 0;
    display: block;
}
</style>